import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const WhyNeedSection = ({ onOpenContactForm }) => {
  const section = useScrollAnimation({ threshold: 0.15 });

  return (
    <section data-testid="why-need-section" ref={section.ref} className="py-24 md:py-32 bg-[#111827] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - big aggressive stats */}
          <div className={`scroll-slide-left ${section.isVisible ? 'scroll-visible' : ''}`}>
            <span className="text-xs font-bold uppercase tracking-widest text-[#FF1010] block mb-4">The Problem Is Real</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-white leading-[1.1] uppercase mb-8" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Without a Trademark,<br />
              <span className="text-[#FF1010]">Your Brand Is Free</span><br />
              for Anyone to Take.
            </h2>

            <div className="grid grid-cols-3 gap-4 mb-8">
              {[
                { num: '87%', label: 'of unregistered brands face infringement' },
                { num: '$350', label: 'average wasted on rejected applications' },
                { num: '8-12', label: 'months to register — start now' }
              ].map((stat, i) => (
                <div key={i} className="border border-white/20 p-4">
                  <span className="text-2xl md:text-3xl font-black text-[#FF1010] block" style={{ fontFamily: "'Outfit', sans-serif" }}>{stat.num}</span>
                  <span className="text-xs text-white/60 leading-tight block mt-1">{stat.label}</span>
                </div>
              ))}
            </div>

            <Button data-testid="why-need-cta" onClick={onOpenContactForm} className="bg-[#FF1010] hover:bg-[#CC0000] text-white font-bold px-8 py-5 text-sm rounded-none uppercase tracking-wider btn-brutal">
              Protect My Brand Now <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>

          {/* Right - text content */}
          <div className={`scroll-slide-right scroll-delay-2 ${section.isVisible ? 'scroll-visible' : ''}`}>
            <div className="space-y-5 text-sm text-white/70 leading-relaxed">
              <p>
                Trademark Agency USA through the USPTO is the only way to get exclusive legal ownership of your brand across all 50 states. Without it, you have no nationwide protection and zero legal standing against competitors, copycats, or counterfeit sellers using your name.
              </p>
              <p>
                A registered trademark gives you the authority to sue infringers, recover damages, and force others to stop using your mark. It is the legal foundation that separates a real brand from an unprotected business name that anyone can copy.
              </p>
              <p>
                Beyond legal protection, trademark registration makes your business more valuable. It is an intellectual property asset that can be licensed, franchised, or sold. Investors and buyers look for registered trademarks as proof of legitimate brand ownership.
              </p>
              <p className="text-white font-semibold">
                The longer you wait, the more exposed you are. Every day without a trademark is a risk you cannot afford.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNeedSection;
